export const sourceDisplayNames = {
  '2Seam': '2 Seam',
  '4SeamLower': '4 Seam Lower',
  '4SeamA': '4 Seam A',
  '4SeamUpper': '4 Seam Upper',
  'MixedOversize': 'Mixed Oversize',
  'Rewash Coal': 'Rewash Coal'
};

export function getDisplayName(name) {
  return sourceDisplayNames[name] || name;
}
